import { useState } from 'react';
import { usePlants, useUpdatePlant, useDeletePlant } from '../../../hooks';

import { Button, Icon } from '@pella/sash-framework';
import { SearchInput } from '../../atoms';
import { SetupCards, PlantDrawer } from '../../molecules';
import * as classes from './Plants.module.css';

/**
 * Component for the Plants setup page.
 */
export const Plants = () => {
  const { data: plants } = usePlants(false);
  const { mutate: updatePlant } = useUpdatePlant();
  const { mutate: deletePlant } = useDeletePlant();

  const [searchValue, setSearchValue] = useState('');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedId, setSelectedId] = useState('');

  const filteredPlants = plants?.filter((plant) => plant.description.toLowerCase().includes(searchValue.toLowerCase()));

  const handleCreatePlant = () => {
    setSelectedId('');
    setDrawerOpen(true);
  };

  /** @type {Local.SetupCardsProps['config']} */
  const cardConfig = {
    id: 'plants-setup-cards',
    pagination: true,
    strictConfirmDelete:
      'Deleting the Plant will cause a cascading effect that deletes Locations, Resources, Queues, Actions, and all Requests associated with this Plant.',
    onEdit: (plant) => {
      setSelectedId(plant.id);
      setDrawerOpen(true);
    },
    onDelete: (id) => deletePlant(id),
    onStatus: (plant) => updatePlant({ id: plant.id, input: { active: !plant.active } }),
    fields: [
      { name: 'organizationName', label: 'Org' },
      { name: 'wmsOrgCode', label: 'WMS Org Code' },
    ],
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    setSelectedId('');
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.searchInput}>
          <SearchInput searchValue={searchValue} onChange={setSearchValue} />
        </div>
        <div className={classes.addButton}>
          <Button color='tertiary' onClick={handleCreatePlant}>
            <Icon name='add' />
            Create Plant
          </Button>
        </div>
      </div>
      <SetupCards data={filteredPlants} config={cardConfig} />
      <PlantDrawer open={drawerOpen} close={handleDrawerClose} data={plants} selectedId={selectedId} />
    </div>
  );
};
